import { useEffect } from "react";
import MainNavigation from "../components/MainNavigation";

export default function Layout({children}) {
    
    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);
    
    return (
    <div className="App">
      <MainNavigation />
      <div className="App-main">
        {children}
      </div>
    </div>
    );
}
